import { render } from "./ProfilPegawai.vue?vue&type=template&id=3bdefd2c"
import script from "./ProfilPegawai.vue?vue&type=script&lang=js"
export * from "./ProfilPegawai.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__